import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { highlights } from "@/data/menuData";

const IMG_MAIN =
  "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/vh256an6_IMG_0095.webp";
const IMG_INSET =
  "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/cdcnqmjz_IMG_0096.webp";

const reveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

export const MenuHighlights = () => {
  const { t, L } = useLang();
  return (
    <section className="gastro" id="kitchen" data-testid="kitchen-section">
      <div className="container">
        <div className="gastro__grid">
          <motion.div
            className="gastro__media"
            initial={{ opacity: 0, scale: 0.985 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          >
            <img src={IMG_MAIN} alt="The table" loading="lazy" />
            <figure className="gastro__media gastro__media--inset">
              <img src={IMG_INSET} alt="The catch" loading="lazy" />
            </figure>
          </motion.div>
          <motion.div className="gastro__text" {...reveal}>
            <p className="label">{t.gastro.label}</p>
            <h2 className="display">
              {t.menuHl.titleA}
              <br />
              <em>{t.menuHl.titleB}</em>
            </h2>
            <p className="gastro__body">{t.gastro.body}</p>
            <Link to="/menu" className="textlink" data-testid="gastro-menu-cta">
              {t.gastro.cta} <span>→</span>
            </Link>
          </motion.div>
        </div>

        <motion.div className="gastro__list" {...reveal}>
          {highlights.map((h, i) => (
            <div className="dish-row" key={h.name.en} data-testid={`dish-card-${i}`}>
              <div className="dish-row__main">
                <div className="dish-row__top">
                  <h3 className="dish-row__name">{L(h.name)}</h3>
                  {h.tag && <span className="dish-row__tag">{L(h.tag)}</span>}
                </div>
                <p className="dish-row__desc">{L(h.desc)}</p>
              </div>
              <div className="dish-row__price">
                {h.price}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          className="gastro__foot"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <p className="gastro__quote">{t.menuHl.quote}</p>
          <Link to="/menu" className="btn btn--dark" data-testid="kitchen-fullmenu-cta">
            {t.menuHl.cta}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default MenuHighlights;
